<template>
  <!-- Wrapping div can be removed in Vue 3 -->
  <div style="display: contents">
    <slot></slot>
    <ConfirmationDialog :confirmation-service="confirmationService" />
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from "vue"
import ConfirmationDialog from "features/common/confirmation-dialog/ConfirmationDialog.vue"
import { ConfirmationService } from "features/common/confirmation-dialog/confirmation.service"

export default defineComponent({
  name: "ConfirmationDialogProvider",
  components: { ConfirmationDialog },
  setup() {
    const _confirmationService = new ConfirmationService()
    provide("ConfirmationService", _confirmationService)
    return {
      confirmationService: _confirmationService,
    }
  },
})
</script>
